import React, { useContext } from "react";

import ElementContext from "../ElementContext";

// Functions import
import { generateClassString as gcs } from "../../lib/helper/generateClassString";

// Component import
import MulticolorHeadline from "./MulticolorHeadline";

import * as styles from "./component.module.less";

export function Headline(props) {
    const {
        headlineClass,
        semanticOfHeadline = "H5 Style",
        accentColor = "#EF7D00",
        children,
        hasLightBackground
    } = props;

    const { isLightBg } = useContext(ElementContext);
    const backgroundIsLight = hasLightBackground ?? isLightBg ?? true;

    switch (
        semanticOfHeadline !== undefined &&
        semanticOfHeadline != null &&
        semanticOfHeadline.length > 0
            ? semanticOfHeadline
            : "H5 Style"
    ) {
        case "H1":
            return (
                <h1 className={gcs(styles.h1, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </h1>
            );

        case "H1 Style":
            return (
                <div className={gcs(styles.h1, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </div>
            );

        case "H2":
            return (
                <h2 className={gcs(styles.h2, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </h2>
            );

        case "H2 Style":
            return (
                <div className={gcs(styles.h2, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </div>
            );

        case "H3":
            return (
                <h3 className={gcs(styles.h3, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </h3>
            );

        case "H3 Style":
            return (
                <div className={gcs(styles.h3, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </div>
            );

        case "H4":
            return (
                <h4 className={gcs(styles.h4, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </h4>
            );

        case "H4 Style":
            return (
                <div className={gcs(styles.h4, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </div>
            );

        case "H5":
            return (
                <h5 className={gcs(styles.h5, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </h5>
            );

        case "H5 Style":
            return (
                <div className={gcs(styles.h5, headlineClass, (!backgroundIsLight ? styles.lightColor : ""))}>
                    <MulticolorHeadline
                        headline={children}
                        accentColor={accentColor}
                    />
                </div>
            );

        default:
            return null;
    }
}
